import { getUserResponse } from './answer-helpers';

function getPropsFromSourceAnswer(currentSlide, results) {
    const { answerSourceId, propsByAnswerId } = currentSlide.props || {};

    if (!answerSourceId || !propsByAnswerId) {
        return null;
    }

    const sourceResponse = getUserResponse(results.userResponses, answerSourceId);

    return sourceResponse ? propsByAnswerId[sourceResponse.id] : null;
}

export {
    getPropsFromSourceAnswer
};
